import CreateEventLandingPage from './CreateEventLandingPage';
export default CreateEventLandingPage;
